export default __webpack_public_path__ + "static/media/pin-hover.db98dddb.svg";